import { S3_BASE_URL, S3_PATHS } from '../config/urls';

export const normalizeS3FileUrl = (originalUrl: string): string => {
  try {
    const [urlWithoutQuery] = originalUrl.split('?');

    if (!urlWithoutQuery.startsWith(S3_BASE_URL)) {
      return originalUrl;
    }

    const rest = urlWithoutQuery.slice(S3_BASE_URL.length);

    return `${S3_BASE_URL}${S3_PATHS.ARCHIVOS_ADJUNTOS}/${rest}`;
  } catch {
    return originalUrl;
  }
};
